export default "__VITE_ASSET__B20rs$VS__"